var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader",on:{"change":_vm.change}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"browse"},[_c('input',{staticClass:"sr-only",attrs:{"id":"file","type":"file","accept":"image/*"}})])
}]

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/Outputs/Images/PhotoEditor/components/loader.vue